var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Vue from 'vue';
import './MtColumn.css';
export default Vue.extend({
    name: 'MtColumn',
    functional: true,
    props: {
        width: {
            type: String,
            validator: function (v) { return ['1of2'].includes(v); },
        },
    },
    render: function (h, _a) {
        var props = _a.props, data = _a.data, children = _a.children;
        var widthClass = props.width && "mt-col--" + props.width;
        return h('div', __assign(__assign({}, data), { class: ['mt-col', widthClass, data.class] }), children);
    },
});
//# sourceMappingURL=MtColumn.js.map